import React from 'react';
import Proptypes from 'prop-types';
import { SAMPLE_PLATE_LETTERS } from '../../../constants/saxs';

class DataCollectionListMeasurementTableRow extends React.Component {
    render() {
        let { dataset } = this.props;
        return (
            <tr class={dataset.runId ? "success" : null}>
                <td> {dataset.macromoleculeAcronym}</td>
                <td> {dataset.specimenConcentration}</td>
                <td>
                    {dataset.bufferAcronym}
                    <span style={{ fontStyle: 'oblique' }}>
                        Plate: [{dataset.samplePlate_slotPositionColumn},
                      {SAMPLE_PLATE_LETTERS[dataset.samplePlatePosition_rowNumber - 1]}-{dataset.samplePlatePosition_columnNumber}]
                    </span>
                </td>
                <td> {dataset.run_exposureTemperature}</td>
                <td> {dataset.measurementVolumeToLoad}</td>
                <td> {dataset.measurementTransmission}</td>
                <td> {dataset.measurementWaitTime}</td>
                <td> {dataset.measurementFlow.toString()}</td>
                <td> {dataset.measurementViscosity} </td>
                <td>
                    <span style={{ fontWeight: 'bold' }} >{dataset.merge_averageFilePath}</span>
                </td>
            </tr>
        )
    }
}

export default DataCollectionListMeasurementTableRow;

DataCollectionListMeasurementTableRow.proptypes = {
    /** dataset */
    dataset: Proptypes.object
}


// WEBPACK FOOTER //
// ./src/components/saxs/DataCollection/DataCollectionListMeasurementTableRow.js